module.exports = __webpack_public_path__ + "static/gallery47-026892df6ad5d3c753174ec463bc2015.png";